import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { map } from 'rxjs';
import { ProjectService } from 'src/app/@domain/project/application/project.service';

@Component({
    selector: 'app-projects-section',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, AsyncPipe],
    styles: `
        @use "variables" as *;

        :host {
            display: block;
            width: 100%;
        }

        .projects-grid {
            display: flex;
            flex-wrap: wrap;
            gap: 0.75rem;
            align-items: flex-start;

            @media screen and (max-width: 768px) {
                display: grid;
                grid-template-rows: repeat(2, auto);
                grid-auto-flow: column;
                gap: 0.5rem;
                overflow-x: auto;
                overflow-y: hidden;
                -webkit-overflow-scrolling: touch;
                scrollbar-width: none;
                -ms-overflow-style: none;

                &::-webkit-scrollbar {
                    display: none;
                }
            }
        }

        .project-btn {
            display: inline-block;
            padding: 0.65rem 1.5rem;
            background-color: $light-blue;
            color: $dark-blue;
            text-decoration: none;
            font-weight: 600;
            font-size: 16px;
            text-transform: uppercase;
            letter-spacing: 0.02em;
            border-radius: 4px !important;
            transition: background-color 200ms ease, color 200ms ease;
            white-space: nowrap;
            width: 256px;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: center;

            &:hover {
                background-color: $red;
                color: #fff;
            }

            @media screen and (max-width: 768px) {
                padding: 0.5rem 1rem;
                font-size: 14px;
            }
        }
    `,
    template: `
        <div class="projects-grid">
            @for (project of projects$ | async; track project.id) {
                <a class="project-btn" [routerLink]="['/projects', project.id]" [title]="project.name">
                    {{ project.name }}
                </a>
            }
        </div>
    `
})
export class ProjectsSectionComponent {
    private projectService = inject(ProjectService);
    
    public projects$ = this.projectService.getProjectsInfos(1, 5).pipe(
        map(response => response.results)
    );
}
